const { NODE_ENV } = process.env;

export const isDevelopment = NODE_ENV === "development";

export const API_URL = isDevelopment
  ? window.location.origin
  : process.env.REACT_APP_API_URL;
